import type { WebsiteHeaderPhotoSchema_PhotoDuoLeft_v1_1_1 } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_DUO_LEFT_v1_1_1: WebsiteHeaderPhotoSchema_PhotoDuoLeft_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoLeft-v1_1_1.json',
  presentationLayout: 'photoDuoLeft',
  photos: [],
};
